import React, { useContext } from "react";
import { generateClassString } from "../../../lib/helper/generateClassString";
import AccordionContext from "../AccordionContext";
import AccordionItemContext from "../AccordionItem/AccordionItemContext";

import * as styles from "./component.module.less";

/**
 *
 *
 * @param {*} {
 *     className,
 *     children,
 *     ...additionalProps
 * }
 * @return {AccordionBody}
 */
export default function AccordionBody({
    className,
    children,
    ...additionalProps
}) {
    const { activeItem } = useContext(AccordionContext);
    const { eventKey } = useContext(AccordionItemContext);

    return (
        <>
            <div
                {...additionalProps}
                className={generateClassString(
                    className,
                    styles.accordionBody,
                    [activeItem === eventKey, "", styles.hidden]
                )}
            >
                {children}
            </div>
        </>
    );
}
